<template>
  <div class='box'>
    <div class='loading' >{{msg}}</div>
  </div>
</template>
<style scoped>
  .box{
    display: table;
    text-align: center;
    width: 100%;height: 100%;
  }
  .loading{display: table-cell;vertical-align: middle;width: 100%;height: 100%;}
</style>
<script>
  import {mtvConfig as CONF, mtvServers as server} from '../services/services'
  export default {
    data () {
      return {
        msg: '处理中…'
      }
    },
    created () {
      this.logout()
    },
    methods: {
// 登出
      logout () {
        let that = this
        server.appServicesGet(this, CONF.APIList.logOut, {}).then(res => {
          if (res.status === CONF.errCode.success.code) {
            document.cookie = 'nickname=;path=/;domain=.ismartv.cn'
            document.cookie = 'isLogin=;path=/;domain=.ismartv.cn'
            if (that.$route.query.callback) {
              location.href = that.$route.query.callback
            } else {
              window.location.href = 'http://m.ismartv.cn'
            }
          } else {
            that.msg = CONF.errCode['code' + res.status].msg
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LogOut.vue?47c909f6